export default "__VITE_ASSET__BN5VGZt0__"